import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

import PopupTitle from "components/common/PopupTitle";
import PopupCloseButton from "components/common/PopupCloseButton";
import { useOnClickOutside } from "hooks/outsideClick.hook";
import { KEYS } from "constants/keyCode";
import { MODAL_ID } from "constants/settings";
import { useScrollBlock } from "hooks/useScrollBlock";
import { useUnmount } from "hooks/useUnmount";

import styles from "./styles.module.scss";

const Popup = ({ children, title, onClose }) => {
    const ref = useRef();

    const [blockScroll, allowScroll] = useScrollBlock();

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === KEYS.ESC) {
                onClose();
            }
        };
        window.addEventListener("keydown", handleEsc);

        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, [onClose]);

    useEffect(() => {
        blockScroll();
    }, [blockScroll]);

    useUnmount(allowScroll);

    useOnClickOutside(ref, onClose);

    return ReactDOM.createPortal(
        <div className={styles.popup}>
            <div className={styles.content} ref={ref}>
                <PopupCloseButton onClose={onClose} />
                {title && <PopupTitle title={title} />}
                {children}
            </div>
        </div>,
        document.getElementById(MODAL_ID),
    );
};

export default Popup;
